import React, { useEffect, useState } from "react";
import Router from "./router";
import classes from "./App.module.css";
import {
  MainHeader,
  UpperHeader,
  Footer,
  WhatsApp,
  Navbar,
} from "./components";
import { jwt } from "./services/index";

/** Redux **/
import { fetchAppSettings } from "./store/general";
import { useDispatch, useSelector } from "react-redux";

function App(props) {
  return (
    <>
      <div className={classes.wrapperContainer}>
        <Navbar />
        <div className={classes.content}>
          <Router />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default App;
